import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'
import { LoaderCircle } from 'lucide-react'
import { buttonVariants } from './button.variants'

function Button({
  className,
  variant,
  size,
  isLoading = false,
  asChild = false,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
    isLoading?: boolean
  }) {
  const Comp = asChild ? Slot : 'button'

  const children = props.children

  if (isLoading) {
    return (
      <Comp
        data-slot='button'
        className={cn(
          buttonVariants({ variant, size, className }),
          'pointer-events-none opacity-50'
        )}
        {...props}
      >
        <LoaderCircle className='animate-spin' />
        {children}
      </Comp>
    )
  }

  return (
    <Comp
      data-slot='button'
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Button }
